enum FileVisibility {
  public = 'public',
  private = 'private',
}

export default FileVisibility
